import { useState } from "react";

import { HStack, VStack } from "@/components/layout";
import { hasProjectReportFinished } from "@/utils";
import ContentsTable from "./contents-table";
import Report from "./report";
import ReportValidator from "./report/validator";

export default function Analysis({ project, isPooling }) {
  const [headings, setHeadings] = useState([]);
  if (!hasProjectReportFinished(project) || isPooling) {
    return <></>;
  }

  return (
    <HStack className="h-full justify-between">
      <VStack className="w-full max-w-5xl">
        <ReportValidator project={project}>
          <Report report={project.promptReport} setHeadings={setHeadings} />
        </ReportValidator>
      </VStack>
      {headings.length > 0 && <ContentsTable headings={headings} />}
    </HStack>
  );
}
